export var environmentProd = {
    FRED: "THIS IS A DUMMY VALUE",
    I_DONT_WANT_THIS_CAR: "956477",
    FOMO_EXPERIMENT_ID: "1101365",
    REQUEST_CALLBACK_EXPERIMENT_ID: "1071651"
};
